import { HTTP } from './helpers/http.js'

export default {
  getOrganizationCatalog(organizationId) {
    return HTTP.get(`/api/v1/organizations/${organizationId}/situation-types`)
  },
}
